import { Component, HostBinding, OnInit } from '@angular/core';
import { AppState } from '@core/store';
import { Store } from '@ngrx/store';
import { cargarSistema } from '@core/store/actions/sistema.actions';

@Component({
	selector: 'select-office',
	styleUrls: ['./select-office.component.scss'],
	// La oficina se selecciona dentro de cada pantalla, no desde el topbar.
	template: ``,
})
export class SelectOfficeComponent implements OnInit {
	@HostBinding('class') class = 'd-flex align-items-center';

	constructor(private readonly store: Store<AppState>) {}

	ngOnInit(): void {
		this.store.dispatch(cargarSistema());
	}
}
